import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { useLang } from 'app/context/i18n';

import 'app/components/BlackFridayBanner/BlackFridayBanner.scss';

export default function BlackFridayBanner() {
  const intl = useIntl();
  const locale = useLang();

  const handleClick = () => {
    window.location.replace(
      `https://www.bigbuy.eu/${locale}/integraciones-mip.html`
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  const plainText = intl
    .formatMessage({
      id: 'controlpanel.my_account.summary.black_friday'
    })
    .replace(/<[^>]*>/g, '');

  return (
    <div
      className="bb-black-friday-banner"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={plainText}
    >
      <p className="bb-black-friday-banner__text">
        <FormattedMessage
          id="controlpanel.my_account.summary.black_friday"
          values={{
            span: (...chunks) => (
              <span className="bb-black-friday-banner__text--yellow">
                {chunks}
              </span>
            )
          }}
        />
      </p>
    </div>
  );
}
